import * as api from '../dealerApi';
import {
  call,
  put,
  select,
  takeEvery
  } from 'redux-saga/effects';
import {
  dealerActionCreators,
  DealerActionKeys,
  FetchDealerPreSeason,
  IPreseasonApiResponse
  } from '..';
import { IState } from '../..';
import { programsActionCreators } from '../../programs';

function* fetchDealerPreseasonSaga(action: FetchDealerPreSeason) {
  const { accountNum, fiscalYear } = action.payload;

  yield put(dealerActionCreators.toggleLoading({ accountNum, type: 'preseason' }));
  const programsLoaded: boolean = yield select((state: IState) => Boolean(state.programs.programs[fiscalYear]));

  const response: IPreseasonApiResponse = yield call(api.fetchPreseason, {
    ...action.payload,
    includePrograms: !programsLoaded
  });

  if (response.programs) {
    yield put(programsActionCreators.setPrograms(response.programs));
  }
  yield put(dealerActionCreators.setPreseason(response));
  yield put(programsActionCreators.setMaxFiscal(response.maxFiscalYear));
  yield put(dealerActionCreators.toggleLoading({ accountNum, type: 'preseason' }));
}

export function* watchFetchDealerPreseason() {
  yield takeEvery(DealerActionKeys.FETCH_DEALER_PRESEASON, fetchDealerPreseasonSaga);
}
